export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
export const SHOW_ALERT = 'SHOW_ALERT';



// WEBPACK FOOTER //
// ./src/events.js